import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const PLANS = [
  { name: "Gratuit", price: "0 FCFA", desc: "Pour deposer ses premieres annonces.", features: ["2 photos par annonce", "Visibilite standard", "Support communautaire"] },
  { name: "Premium", price: "2 000 FCFA", desc: "Pour booster la visibilite pendant 1 mois.", features: ["Jusqu'a 6 photos par annonce", "Remontee auto 48 h", "Badge Or Vendeur Pro", "IA Booster illimitee"], popular: true },
  { name: "Pro / Hotel", price: "Sur devis", desc: "Pour agences, pros et hotels partenaires.", features: ["Annonces illimitees", "Module hotelier intelligent", "Dashboard analytics", "Account manager dedie"] },
];

export default function AbonnementsPage() {
  return (
    <main className="max-w-7xl mx-auto px-6 py-10" data-testid="abonnements-page">
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight">Abonnements</h1>
      <p className="text-[var(--ink-soft)] mt-2">Paiement local Wave / Orange Money / MTN. Tarifs adaptes au marche ivoirien.</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        {PLANS.map((p) => (
          <div key={p.name} className={`glass-card p-7 relative ${p.popular ? "ring-2 ring-orange-500" : ""}`} data-testid={`plan-${p.name}`}>
            {p.popular && <div className="absolute -top-3 left-7 badge-premium">Le plus populaire</div>}
            <div className="font-bold text-lg">{p.name}</div>
            <div className="text-3xl font-extrabold mt-1 text-orange-600">{p.price}</div>
            <div className="text-sm text-[var(--ink-soft)] mt-1">{p.desc}</div>
            <ul className="mt-5 space-y-2 text-sm">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2"><CheckCircle2 size={16} className="text-green-600 mt-0.5 shrink-0" /> {f}</li>
              ))}
            </ul>
            <Link to="/deposer" className="btn-primary w-full mt-6 inline-flex justify-center">Choisir</Link>
          </div>
        ))}
      </div>
    </main>
  );
}
